// import { TypographyStyleOptions } from '@mui/material/styles/createTypography'
// import { TypographyOptions } from '@mui/material/styles/createTypography'

import { TypographyVariantsOptions } from '@mui/material'

const typography: TypographyVariantsOptions = {
  fontFamily: 'Roboto, Open Sans, sans-serif',
  fontSize: 16,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  h1: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: '6rem',
    fontWeight: 300,
    letterSpacing: -0.015,
  },
  h2: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: '3.75rem',
    fontWeight: 300,
    letterSpacing: -0.005,
  },
  h3: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: '3rem',
    fontWeight: 400,
  },
  h4: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: '2.125rem',
    fontWeight: 400,
    letterSpacing: 0.0025,
  },
  h5: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: '1.5rem',
    fontWeight: 400,
  },
  h6: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: '1.25rem',
    fontWeight: 500,
    letterSpacing: 0.0015,
  },
  subtitle1: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: '1rem',
    fontWeight: 400,
    letterSpacing: 0.0015,
  },
  subtitle2: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: '0.875rem',
    fontWeight: 500,
    letterSpacing: 0.001,
  },
  body1: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: '1rem',
    fontWeight: 400,
    letterSpacing: 0.005,
  },
  body2: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: '0.875rem',
    fontWeight: 400,
    letterSpacing: 0.0025,
  },
  button: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: '0.875rem',
    fontWeight: 500,
    letterSpacing: 0.0125,
    textTransform: 'uppercase',
  },
  buttonSmall: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: '0.75rem',
    fontWeight: 500,
    letterSpacing: 0.0125,
    textTransform: 'uppercase',
  },
  caption: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: '0.75rem',
    fontWeight: 400,
    letterSpacing: 0.04,
  },
  overline: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: '0.75rem',
    fontWeight: 400,
    letterSpacing: 0.015,
    textTransform: 'none',
  },
}

export default typography
